import { COLORS, palette } from '../../theme/palette.ts';

export function NotFoundImage(): JSX.Element {
  const dot1Color = palette.primary.main;
  const dot2Color = palette.secondary.main;

  const line1Color = '#B5B5B5';
  const line2Color = '#D4D4D4';
  const line3Color = '#848484';

  const imageColor = COLORS.TEXT_DARK;

  return (
    <svg
      width="850"
      height="863"
      viewBox="0 0 850 863"
      preserveAspectRatio="xMaxYMax meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M426.285 828.987L673.224 845.407C673.394 845.419 673.544 845.288 673.554 845.116C673.574 844.944 673.444 844.795 673.264 844.784L426.325 828.364C426.155 828.352 426.005 828.483 425.995 828.655C425.985 828.827 426.115 828.976 426.285 828.987Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M632.534 772.314L672.974 845.247C673.054 845.398 673.244 845.452 673.394 845.369C673.544 845.285 673.604 845.095 673.524 844.944L633.084 772.011C633.004 771.86 632.814 771.806 632.664 771.889C632.504 771.973 632.454 772.163 632.534 772.314Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M673.064 845.296L634.334 862.978H635.834L673.324 845.864C673.474 845.793 673.544 845.607 673.474 845.45C673.404 845.293 673.224 845.224 673.064 845.296Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M673.274 845.407L794.493 836.279C794.673 836.266 794.803 836.116 794.783 835.944C794.773 835.772 794.623 835.642 794.453 835.655L673.224 844.784C673.054 844.797 672.924 844.947 672.934 845.119C672.944 845.291 673.094 845.42 673.274 845.407Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M162.267 718.494C162.267 718.494 162.274 718.494 15.8867 862.974C16.2467 862.974 16.4247 862.974 16.7877 862.974L162.706 718.939C162.829 718.818 162.83 718.62 162.709 718.497C162.588 718.374 162.39 718.373 162.267 718.494Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M264.089 799.743L162.682 718.475C162.548 718.367 162.351 718.388 162.243 718.523C162.135 718.658 162.157 718.854 162.291 718.962L263.698 800.231C263.833 800.338 264.03 800.317 264.138 800.182C264.246 800.048 264.224 799.851 264.089 799.743Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M325.149 663.659L264.177 800.118L263.611 799.854L324.582 663.395L325.149 663.659Z"
        fill={line3Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M162.603 719.007L244.508 686.1L317.91 654.865L318.277 654.718C318.437 654.653 318.514 654.471 318.45 654.311C318.386 654.151 318.204 654.073 318.044 654.138L162.37 718.427C162.21 718.492 162.132 718.674 162.197 718.834C162.261 718.994 162.443 719.072 162.603 719.007Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M263.839 800.294L426.015 829.03C426.185 829.06 426.345 828.946 426.375 828.776C426.405 828.607 426.295 828.444 426.125 828.414L263.948 799.679C263.779 799.649 263.616 799.762 263.586 799.932C263.556 800.102 263.67 800.264 263.839 800.294Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M486.865 747.429L425.815 828.534C425.715 828.672 425.745 828.868 425.875 828.972C426.015 829.075 426.215 829.048 426.315 828.91L487.365 747.805C487.465 747.667 487.435 747.471 487.295 747.367C487.165 747.264 486.965 747.291 486.865 747.429Z"
        fill={line3Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M341.032 664.509L425.785 828.865C425.865 829.018 426.055 829.079 426.215 829C426.365 828.921 426.425 828.732 426.345 828.579L341.587 664.222C341.508 664.069 341.319 664.009 341.166 664.088C341.013 664.167 340.952 664.356 341.032 664.509Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M487.275 747.354L349.222 656.275C349.077 656.183 348.883 656.226 348.791 656.371C348.698 656.516 348.741 656.71 348.886 656.802L486.945 747.881C487.085 747.973 487.285 747.93 487.375 747.785C487.465 747.64 487.425 747.446 487.275 747.354Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M479.465 671.945L486.794 747.648C486.814 747.82 486.965 747.946 487.145 747.929C487.315 747.912 487.435 747.76 487.425 747.588L480.085 671.884C480.065 671.713 479.915 671.587 479.745 671.603C479.565 671.62 479.445 671.773 479.465 671.945Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M479.815 671.604L350.056 650.584C349.885 650.558 349.726 650.676 349.7 650.846C349.674 651.017 349.792 651.176 349.962 651.202L479.725 672.222C479.895 672.248 480.055 672.131 480.085 671.96C480.105 671.79 479.985 671.63 479.815 671.604Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M480.074 671.978L503.294 563.536C503.334 563.367 503.224 563.201 503.054 563.165C502.884 563.129 502.724 563.236 502.684 563.405L479.465 671.847C479.435 672.016 479.535 672.182 479.705 672.218C479.875 672.254 480.044 672.147 480.074 671.978Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M622.214 598.951L503.084 563.172C502.914 563.122 502.744 563.216 502.694 563.381C502.644 563.547 502.734 563.721 502.904 563.771L622.034 599.55C622.204 599.599 622.374 599.506 622.424 599.34C622.474 599.175 622.384 599.001 622.214 598.951Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M621.984 598.971L479.635 671.634C479.475 671.713 479.415 671.901 479.495 672.055C479.575 672.208 479.754 672.269 479.914 672.191L622.264 599.528C622.424 599.45 622.484 599.261 622.404 599.108C622.324 598.954 622.134 598.893 621.984 598.971Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M479.605 672.175L632.644 772.424C632.784 772.518 632.974 772.478 633.074 772.334C633.164 772.189 633.124 771.996 632.984 771.901L479.945 671.652C479.795 671.558 479.605 671.598 479.505 671.742C479.415 671.887 479.455 672.08 479.605 672.175Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M632.864 771.853L487.704 747.051C487.534 747.022 487.374 747.137 487.344 747.307C487.314 747.477 487.434 747.638 487.604 747.667L632.754 772.47C632.924 772.499 633.094 772.384 633.124 772.214C633.144 772.044 633.034 771.883 632.864 771.853Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M426.405 828.771L632.894 772.464C633.054 772.419 633.154 772.247 633.114 772.08C633.064 771.914 632.894 771.816 632.724 771.861L426.235 828.168C426.075 828.213 425.975 828.385 426.025 828.552C426.065 828.718 426.235 828.816 426.405 828.771Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M621.814 599.269L632.494 772.181C632.504 772.353 632.654 772.484 632.834 772.473C633.004 772.463 633.134 772.314 633.124 772.142L622.434 599.23C622.424 599.058 622.274 598.927 622.104 598.938C621.934 598.948 621.804 599.097 621.814 599.269Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M773.173 630.555L742.853 724.532C742.803 724.696 742.893 724.872 743.053 724.925C743.223 724.978 743.393 724.888 743.453 724.724L773.763 630.747C773.813 630.583 773.723 630.406 773.563 630.353C773.403 630.301 773.223 630.391 773.173 630.555Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M622.064 599.556L773.403 630.956C773.573 630.991 773.733 630.882 773.773 630.713C773.803 630.544 773.703 630.379 773.533 630.344L622.194 598.944C622.024 598.909 621.854 599.017 621.824 599.186C621.784 599.355 621.894 599.521 622.064 599.556Z"
        fill={line3Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M743.023 724.342L632.684 771.875C632.524 771.944 632.454 772.128 632.524 772.286C632.594 772.445 632.774 772.518 632.934 772.45L743.273 724.916C743.433 724.848 743.503 724.664 743.443 724.505C743.373 724.347 743.183 724.274 743.023 724.342Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M793.803 836.56L632.694 772.453C632.534 772.389 632.454 772.207 632.524 772.047C632.584 771.887 632.764 771.808 632.924 771.872L794.123 836.016C794.183 836.039 794.233 836.081 794.273 836.134L811.933 862.977H811.183L793.803 836.56Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M794.243 836.51L849.943 772.775C850.063 772.645 849.583 772.237 849.473 772.367L793.773 836.102C793.663 836.233 793.673 836.43 793.803 836.543C793.943 836.655 794.133 836.641 794.243 836.51Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M743.023 724.914L849.943 772.775V772.091L743.283 724.344C743.123 724.273 742.933 724.344 742.863 724.501C742.793 724.659 742.863 724.844 743.023 724.914Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M773.693 630.861L849.943 547.361V546.434L773.233 630.439C773.123 630.566 773.133 630.764 773.253 630.881C773.383 630.997 773.583 630.988 773.693 630.861Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M426.165 827.756L422.695 862.977H423.325L426.785 827.818C426.795 827.646 426.675 827.493 426.505 827.476C426.335 827.459 426.175 827.585 426.165 827.756Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M264.03 799.578C264.03 799.578 270.149 799.578 15.8921 862.983C16.2048 862.984 18.2459 862.981 18.4752 862.983C270.3 800.184 264.181 800.184 264.181 800.184C264.348 800.142 264.45 799.973 264.409 799.805C264.367 799.638 264.198 799.536 264.03 799.578Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M721.374 470.345L773.173 630.747C773.223 630.911 773.403 631.001 773.563 630.948C773.723 630.895 773.813 630.719 773.763 630.555L721.964 470.153C721.914 469.989 721.744 469.898 721.574 469.951C721.414 470.004 721.324 470.181 721.374 470.345Z"
        fill={line3Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M263.793 799.935L276.507 862.976C276.707 862.976 276.929 862.976 277.145 862.976L264.405 799.811C264.371 799.642 264.206 799.532 264.037 799.567C263.868 799.601 263.759 799.766 263.793 799.935Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M772.763 629.935L849.943 702.037V701.182L773.183 629.479C773.063 629.361 772.863 629.368 772.743 629.494C772.623 629.62 772.633 629.818 772.763 629.935Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M721.423 470.056L621.404 598.239C621.304 598.375 621.324 598.572 621.464 598.678C621.594 598.784 621.794 598.76 621.904 598.624L721.913 470.441C722.023 470.305 722.003 470.108 721.863 470.002C721.723 469.896 721.533 469.92 721.423 470.056Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M721.673 470.561H849.943C849.943 470.308 849.943 470.148 849.943 469.936H721.673C721.503 469.936 721.364 470.076 721.364 470.249C721.364 470.421 721.503 470.561 721.673 470.561Z"
        fill={line1Color}
      />
      <path
        d="M622.188 607.065C626.029 607.065 629.142 603.952 629.142 600.112C629.142 596.271 626.029 593.158 622.188 593.158C618.348 593.158 615.235 596.271 615.235 600.112C615.235 603.952 618.348 607.065 622.188 607.065Z"
        fill={dot2Color}
      />
      <path
        d="M503.053 575.029C508.922 575.029 513.68 570.271 513.68 564.402C513.68 558.533 508.922 553.775 503.053 553.775C497.184 553.775 492.427 558.533 492.427 564.402C492.427 570.271 497.184 575.029 503.053 575.029Z"
        fill={dot2Color}
      />
      <path
        d="M673.192 852.739C677.142 852.739 680.343 849.537 680.343 845.588C680.343 841.638 677.142 838.436 673.192 838.436C669.242 838.436 666.04 841.638 666.04 845.588C666.04 849.537 669.242 852.739 673.192 852.739Z"
        fill={dot2Color}
      />
      <path
        d="M487.114 752.271C490.049 752.271 492.427 749.892 492.427 746.958C492.427 744.023 490.049 741.645 487.114 741.645C484.18 741.645 481.801 744.023 481.801 746.958C481.801 749.892 484.18 752.271 487.114 752.271Z"
        fill={dot2Color}
      />
      <path
        d="M743.157 729.949C746.092 729.949 748.471 727.57 748.471 724.636C748.471 721.701 746.092 719.322 743.157 719.322C740.223 719.322 737.844 721.701 737.844 724.636C737.844 727.57 740.223 729.949 743.157 729.949Z"
        fill={dot2Color}
      />
      <path
        d="M162.489 724.031C165.424 724.031 167.802 721.652 167.802 718.718C167.802 715.783 165.424 713.404 162.489 713.404C159.555 713.404 157.176 715.783 157.176 718.718C157.176 721.652 159.555 724.031 162.489 724.031Z"
        fill={dot2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M336.512 664.865C335.94 664.952 335.356 665.038 334.76 665.068C334.245 665.097 333.851 665.529 333.883 666.047C333.915 666.565 334.359 666.967 334.877 666.938C335.544 666.909 336.2 666.822 336.845 666.706C337.354 666.62 337.693 666.13 337.601 665.612C337.511 665.094 337.024 664.749 336.512 664.865ZM331.241 664.869C330.656 664.783 330.081 664.64 329.522 664.468C329.024 664.324 328.504 664.612 328.357 665.102C328.211 665.62 328.496 666.138 328.991 666.281C329.622 666.453 330.266 666.625 330.925 666.711C331.435 666.826 331.918 666.48 332.007 665.962C332.093 665.444 331.75 664.955 331.241 664.869ZM341.457 663.048C340.951 663.336 340.428 663.596 339.884 663.826C339.409 664.028 339.194 664.604 339.402 665.064C339.606 665.524 340.159 665.754 340.633 665.552C341.243 665.293 341.833 664.976 342.402 664.659C342.851 664.399 343 663.824 342.741 663.364C342.479 662.932 341.906 662.76 341.457 663.048ZM326.281 663.089C325.768 662.802 325.273 662.485 324.801 662.14C324.384 661.824 323.797 661.911 323.489 662.343C323.182 662.746 323.271 663.35 323.689 663.638C324.218 664.04 324.774 664.385 325.35 664.73C325.799 664.989 326.371 664.815 326.627 664.384C326.886 663.923 326.73 663.348 326.281 663.089ZM345.486 659.62C345.109 660.081 344.707 660.513 344.279 660.916C343.902 661.262 343.888 661.866 344.242 662.24C344.599 662.614 345.192 662.642 345.569 662.268C346.049 661.836 346.5 661.346 346.926 660.828C347.256 660.425 347.204 659.849 346.807 659.504C346.412 659.188 345.82 659.217 345.486 659.62ZM322.224 659.725C321.841 659.265 321.486 658.805 321.158 658.316C320.87 657.885 320.288 657.77 319.857 658.058C319.429 658.347 319.311 658.922 319.599 659.353C319.968 659.9 320.365 660.446 320.794 660.935C321.129 661.338 321.722 661.395 322.115 661.049C322.509 660.704 322.558 660.128 322.224 659.725ZM348.118 655.072C347.917 655.619 347.685 656.166 347.42 656.684C347.191 657.144 347.378 657.72 347.839 657.95C348.302 658.179 348.866 657.977 349.099 657.517C349.392 656.941 349.656 656.337 349.883 655.703C350.058 655.214 349.807 654.668 349.321 654.495C348.834 654.323 348.296 654.582 348.118 655.072ZM319.552 655.181C319.348 654.635 319.175 654.059 319.036 653.484C318.912 652.995 318.405 652.678 317.902 652.794C317.398 652.938 317.091 653.428 317.212 653.945C317.371 654.578 317.567 655.211 317.795 655.844C317.977 656.333 318.515 656.563 319.001 656.39C319.487 656.217 319.734 655.67 319.552 655.181ZM349.026 649.863L349.023 649.661C349.017 649.143 349.431 648.711 349.946 648.711C350.464 648.71 350.89 649.113 350.9 649.631L350.9 649.861C350.9 650.523 350.863 651.185 350.789 651.847C350.729 652.365 350.263 652.739 349.751 652.682C349.236 652.596 348.867 652.136 348.924 651.647C348.993 651.043 349.027 650.467 349.026 649.863ZM318.602 650.002C318.602 649.973 318.602 649.916 318.602 649.887C318.601 649.34 318.632 648.794 318.689 648.247C318.747 647.729 318.372 647.269 317.86 647.212C317.345 647.154 316.882 647.529 316.827 648.047C316.762 648.651 316.728 649.256 316.728 649.889C316.728 649.946 316.728 649.975 316.728 650.004C316.732 650.522 317.155 650.953 317.673 650.953C318.191 650.952 318.608 650.52 318.602 650.002ZM348.038 644.482C348.246 645.029 348.424 645.604 348.569 646.151C348.693 646.669 349.202 646.985 349.706 646.841C350.207 646.725 350.511 646.207 350.387 645.718C350.222 645.056 350.023 644.423 349.79 643.819C349.608 643.33 349.064 643.1 348.581 643.273C348.097 643.446 347.853 643.993 348.038 644.482ZM319.472 644.793C319.67 644.246 319.9 643.699 320.159 643.181C320.388 642.72 320.198 642.145 319.732 641.915C319.268 641.685 318.707 641.887 318.477 642.348C318.187 642.924 317.929 643.557 317.708 644.161C317.533 644.651 317.789 645.197 318.276 645.369C318.765 645.542 319.3 645.282 319.472 644.793ZM345.338 639.967C345.721 640.398 346.081 640.858 346.412 641.347C346.701 641.778 347.285 641.893 347.713 641.605C348.142 641.317 348.254 640.741 347.963 640.31C347.591 639.763 347.188 639.246 346.758 638.728C346.419 638.326 345.826 638.297 345.435 638.643C345.044 638.96 344.998 639.564 345.338 639.967ZM322.073 640.215C322.449 639.755 322.849 639.323 323.275 638.92C323.646 638.574 323.659 637.97 323.299 637.596C322.942 637.222 322.347 637.223 321.973 637.568C321.498 638.029 321.047 638.519 320.627 639.008C320.297 639.411 320.355 640.015 320.755 640.332C321.152 640.677 321.745 640.619 322.073 640.215ZM341.258 636.603C341.77 636.89 342.268 637.235 342.743 637.58C343.161 637.868 343.748 637.781 344.053 637.349C344.357 636.946 344.265 636.371 343.844 636.054C343.312 635.652 342.756 635.307 342.177 634.991C341.725 634.732 341.153 634.877 340.9 635.337C340.647 635.798 340.806 636.373 341.258 636.603ZM326.078 636.788C326.585 636.5 327.108 636.212 327.649 635.981C328.121 635.75 328.333 635.204 328.123 634.743C327.912 634.254 327.36 634.053 326.885 634.255C326.278 634.543 325.691 634.831 325.125 635.177C324.679 635.437 324.533 636.012 324.795 636.444C325.06 636.904 325.636 637.047 326.078 636.788ZM336.284 634.881C336.871 634.966 337.447 635.11 338.008 635.253C338.503 635.397 339.023 635.109 339.167 634.619C339.308 634.101 339.019 633.583 338.524 633.469C337.891 633.268 337.246 633.124 336.587 633.01C336.078 632.924 335.595 633.27 335.512 633.788C335.429 634.306 335.774 634.795 336.284 634.881ZM331.012 634.942C331.585 634.827 332.169 634.74 332.761 634.711C333.279 634.682 333.67 634.221 333.635 633.703C333.598 633.185 333.151 632.811 332.636 632.84C331.969 632.87 331.313 632.957 330.668 633.072C330.159 633.188 329.823 633.677 329.918 634.166C330.013 634.684 330.503 635.029 331.012 634.942Z"
        fill={dot1Color}
      />
      <path
        d="M772.461 643.116C779.361 643.116 784.954 637.523 784.954 630.624C784.954 623.724 779.361 618.131 772.461 618.131C765.562 618.131 759.968 623.724 759.968 630.624C759.968 637.523 765.562 643.116 772.461 643.116Z"
        fill={dot1Color}
      />
      <path
        d="M721.679 477.521C725.694 477.521 728.95 474.265 728.95 470.25C728.95 466.234 725.694 462.979 721.679 462.979C717.663 462.979 714.407 466.234 714.407 470.25C714.407 474.265 717.663 477.521 721.679 477.521Z"
        fill={dot1Color}
      />
      <path
        d="M479.776 679.214C483.808 679.214 487.076 675.946 487.076 671.914C487.076 667.882 483.808 664.613 479.776 664.613C475.744 664.613 472.475 667.882 472.475 671.914C472.475 675.946 475.744 679.214 479.776 679.214Z"
        fill={dot1Color}
      />
      <path
        d="M631.97 776.349C634.19 776.349 635.989 774.55 635.989 772.33C635.989 770.11 634.19 768.311 631.97 768.311C629.75 768.311 627.951 770.11 627.951 772.33C627.951 774.55 629.75 776.349 631.97 776.349Z"
        fill={dot1Color}
      />
      <path
        d="M263.895 804.003C266.115 804.003 267.914 802.204 267.914 799.984C267.914 797.764 266.115 795.965 263.895 795.965C261.675 795.965 259.876 797.764 259.876 799.984C259.876 802.204 261.675 804.003 263.895 804.003Z"
        fill={dot1Color}
      />
      <path
        d="M793.848 842.139C797.567 842.139 800.582 839.123 800.582 835.404C800.582 831.685 797.567 828.67 793.848 828.67C790.128 828.67 787.113 831.685 787.113 835.404C787.113 839.123 790.128 842.139 793.848 842.139Z"
        fill={dot1Color}
      />
      <path
        d="M426.311 835.966C430.227 835.966 433.401 832.701 433.401 828.674C433.401 824.647 430.227 821.383 426.311 821.383C422.395 821.383 419.221 824.647 419.221 828.674C419.221 832.701 422.395 835.966 426.311 835.966Z"
        fill={dot1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M728.543 114.224L849.963 105.475V106.1L728.583 114.847C728.413 114.859 728.263 114.728 728.253 114.556C728.243 114.384 728.373 114.235 728.543 114.224Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M558.995 126.733L464.941 224.736C464.807 224.844 464.61 224.823 464.502 224.688C464.394 224.553 464.416 224.357 464.55 224.249L558.605 126.245C558.739 126.137 558.936 126.159 559.044 126.294C559.152 126.428 559.13 126.625 558.995 126.733Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M636.356 293.197L559.61 126.148L559.044 126.411L635.789 293.461L636.356 293.197Z"
        fill={line3Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M464.862 224.203L636.189 293.038C636.349 293.102 636.427 293.284 636.363 293.445C636.298 293.605 636.116 293.682 635.956 293.618L464.629 224.783C464.469 224.718 464.391 224.536 464.456 224.376C464.52 224.216 464.702 224.138 464.862 224.203Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M559.366 126.049L728.274 114.182C728.444 114.152 728.604 114.266 728.634 114.436C728.664 114.605 728.554 114.768 728.384 114.798L559.475 126.665C559.305 126.695 559.143 126.581 559.112 126.411C559.082 126.242 559.196 126.079 559.366 126.049Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M789.123 195.782L728.073 114.677C727.973 114.539 728.003 114.343 728.133 114.239C728.273 114.136 728.473 114.163 728.573 114.301L789.623 195.406C789.723 195.544 789.693 195.74 789.553 195.844C789.423 195.947 789.223 195.92 789.123 195.782Z"
        fill={line3Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M635.795 293.185L728.044 114.346C728.124 114.193 728.314 114.132 728.474 114.211C728.624 114.29 728.684 114.479 728.604 114.632L636.35 293.471C636.271 293.625 636.083 293.685 635.929 293.606C635.776 293.527 635.716 293.338 635.795 293.185Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M789.533 195.857L636.241 293.592C636.095 293.684 635.902 293.641 635.809 293.496C635.716 293.351 635.759 293.157 635.905 293.065L789.203 195.33C789.343 195.238 789.543 195.281 789.633 195.426C789.723 195.571 789.683 195.765 789.533 195.857Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M781.723 271.266L789.053 195.563C789.073 195.391 789.223 195.265 789.403 195.282C789.573 195.299 789.693 195.451 789.683 195.623L782.343 271.327C782.323 271.498 782.173 271.624 782.003 271.608C781.823 271.591 781.703 271.438 781.723 271.266Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M782.073 271.607L636.119 293.637C635.949 293.663 635.789 293.545 635.764 293.375C635.738 293.204 635.855 293.045 636.026 293.019L781.983 270.989C782.153 270.963 782.313 271.08 782.343 271.251C782.363 271.421 782.243 271.581 782.073 271.607Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M782.333 271.231L805.553 379.673C805.593 379.842 805.483 380.008 805.313 380.044C805.143 380.08 804.983 379.973 804.943 379.804L781.723 271.362C781.693 271.193 781.793 271.027 781.963 270.991C782.133 270.955 782.303 271.062 782.333 271.231Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M849.963 365.984V366.637L805.343 380.039C805.173 380.089 805.003 379.995 804.953 379.83C804.903 379.664 804.993 379.49 805.163 379.44L849.963 365.984Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M849.963 305.623V306.324L781.893 271.575C781.733 271.496 781.673 271.308 781.753 271.154C781.833 271.001 782.013 270.94 782.173 271.018L849.963 305.623Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M781.863 271.036L849.963 226.797V227.542L782.203 271.559C782.053 271.653 781.863 271.613 781.763 271.469C781.673 271.324 781.713 271.131 781.863 271.036Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M849.963 185.522V186.156L789.963 196.16C789.793 196.189 789.633 196.074 789.603 195.904C789.573 195.734 789.693 195.573 789.863 195.544L849.963 185.522Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M728.664 114.439L849.963 147.719V148.367L728.494 115.042C728.334 114.997 728.234 114.825 728.284 114.658C728.324 114.492 728.494 114.394 728.664 114.439Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M721.579 21.6336C721.419 21.5886 721.309 20.9115 721.899 21.0695C724.909 21.8955 742.389 26.6935 849.969 56.2075V56.8555L721.579 21.6336Z"
        fill={line2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M728.424 115.455C728.424 115.455 722.404 54.3659 719.064 20.389H719.694C723.034 54.3049 729.044 115.393 729.044 115.393C729.054 115.565 728.934 115.718 728.764 115.735C728.594 115.752 728.434 115.626 728.424 115.455Z"
        fill={line1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M559.165 125.859C559.165 125.859 671.63 58.644 720.772 19.1593L721.262 19.5679C672.022 59.1318 559.556 126.347 559.556 126.347C559.422 126.455 559.225 126.434 559.117 126.298C559.009 126.164 559.03 125.967 559.165 125.859Z"
        fill={line1Color}
      />
      <path
        d="M805.313 368.184C811.182 368.184 815.94 372.942 815.94 378.811C815.94 384.68 811.182 389.438 805.313 389.438C799.444 389.438 794.687 384.68 794.687 378.811C794.687 372.942 799.444 368.184 805.313 368.184Z"
        fill={dot2Color}
      />
      <path
        d="M719.956 15.6932C723.034 15.6932 725.529 18.1885 725.529 21.2665C725.529 24.3446 723.034 26.8398 719.956 26.8398C716.878 26.8398 714.383 24.3446 714.383 21.2665C714.383 18.1885 716.878 15.6932 719.956 15.6932Z"
        fill={dot2Color}
      />
      <path
        d="M789.372 190.94C792.307 190.94 794.685 193.319 794.685 196.253C794.685 199.188 792.307 201.566 789.372 201.566C786.438 201.566 784.059 199.188 784.059 196.253C784.059 193.319 786.438 190.94 789.372 190.94Z"
        fill={dot2Color}
      />
      <path
        d="M464.747 219.18C467.682 219.18 470.061 221.559 470.061 224.493C470.061 227.428 467.682 229.807 464.747 229.807C461.813 229.807 459.434 227.428 459.434 224.493C459.434 221.559 461.813 219.18 464.747 219.18Z"
        fill={dot2Color}
      />
      <path
        d="M636.078 283.507C641.507 283.507 645.907 287.908 645.907 293.337C645.907 298.765 641.507 303.166 636.078 303.166C630.65 303.166 626.249 298.765 626.249 293.337C626.249 287.908 630.65 283.507 636.078 283.507Z"
        fill={dot1Color}
      />
      <path
        d="M782.035 263.991C786.067 263.991 789.335 267.26 789.335 271.291C789.335 275.323 786.067 278.592 782.035 278.592C778.003 278.592 774.734 275.323 774.734 271.291C774.734 267.26 778.003 263.991 782.035 263.991Z"
        fill={dot1Color}
      />
      <path
        d="M559.047 122.278C561.266 122.278 563.066 124.077 563.066 126.297C563.066 128.517 561.266 130.316 559.047 130.316C556.827 130.316 555.027 128.517 555.027 126.297C555.027 124.077 556.827 122.278 559.047 122.278Z"
        fill={dot1Color}
      />
      <path
        d="M728.57 107.245C732.486 107.245 735.66 110.51 735.66 114.537C735.66 118.564 732.486 121.828 728.57 121.828C724.654 121.828 721.48 118.564 721.48 114.537C721.48 110.51 724.654 107.245 728.57 107.245Z"
        fill={dot1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.825 468.353C217.593 467.918 203.105 492.19 203.457 492.441C230.313 511.56 296.922 526.305 340.335 492.441C340.515 492.301 318.041 468.171 317.725 468.353C297.147 480.205 254.949 481.098 218.825 468.353ZM219.149 470.231C216.288 473.592 207.908 487.507 205.559 491.872C220.436 501.977 246.483 510.66 273.934 511.04C296.059 511.347 317.2 506.336 336.035 492.256C332.094 487.851 321.078 473.937 317.495 470.388C296.435 481.753 254.968 482.62 219.149 470.231Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M216.399 473.36C216.399 473.36 240.109 483.569 267.701 485.297C286.22 486.457 307.412 483.063 320.935 472.994C321.304 472.719 321.38 472.197 321.105 471.828C320.83 471.459 320.308 471.382 319.939 471.657C306.711 481.508 287.636 483.473 269.52 482.338C242.16 480.624 216.951 471.788 216.951 471.788C216.517 471.636 216.041 471.864 215.889 472.298C215.736 472.732 215.965 473.208 216.399 473.36Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M230.54 483.348C233.38 483.348 235.686 485.385 235.686 487.894C235.686 490.403 233.38 492.44 230.54 492.44C227.701 492.44 225.396 490.403 225.396 487.894C225.396 485.385 227.701 483.348 230.54 483.348ZM230.935 484.93C233.045 484.93 234.436 486.03 234.436 487.894C234.436 489.759 232.651 491.19 230.54 491.19C229.171 490.994 227.516 489.635 227.516 487.77C227.572 485.915 229.946 484.887 230.935 484.93Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M261.196 491.006C264.309 491.006 266.835 493.121 266.835 495.726C266.835 498.331 264.309 500.445 261.196 500.445C258.084 500.445 255.557 498.331 255.557 495.726C255.557 493.121 258.084 491.006 261.196 491.006ZM261.196 492.256C263.564 492.258 265.585 493.744 265.585 495.726C265.585 497.708 263.564 499.195 261.196 499.195C259.61 499.029 258.357 497.778 258.357 495.796C258.357 493.814 259.955 492.206 261.196 492.256Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M288.095 491.006C290.899 491.006 293.177 492.817 293.177 495.048C293.177 497.278 290.899 499.089 288.095 499.089C285.29 499.089 283.013 497.278 283.013 495.048C283.013 492.817 285.29 491.006 288.095 491.006ZM288.095 492.256C290.143 492.256 291.927 493.419 291.927 495.048C291.927 496.676 290.143 497.839 288.095 497.839C286.047 497.839 285.336 496.62 285.336 494.992C285.336 493.363 286.504 492.296 288.095 492.256Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M311.75 483.348C314.043 483.348 315.904 485.12 315.904 487.303C315.904 489.486 314.043 491.258 311.75 491.258C309.458 491.258 307.597 489.486 307.597 487.303C307.597 485.12 309.458 483.348 311.75 483.348ZM311.75 484.598C313.336 484.551 314.654 485.793 314.654 487.303C314.654 488.813 313.337 490.008 311.75 490.008C310.164 490.008 309.717 488.839 309.717 487.329C309.717 485.819 310.837 484.626 311.75 484.598Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.62 469.681C228.827 440.616 251.703 431.172 268.379 430.545C291.305 429.684 309.031 443.105 316.629 469.741C316.755 470.183 317.216 470.44 317.659 470.313C318.101 470.187 318.358 469.726 318.232 469.283C310.386 441.776 291.981 427.1 268.305 427.989C251.123 428.635 227.518 439.229 218.031 469.178C217.892 469.616 218.135 470.085 218.574 470.224C219.012 470.363 219.481 470.12 219.62 469.681Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.019 500.234C218.019 500.234 216.282 506.915 216.468 510.917C216.523 512.117 216.769 513.101 217.196 513.702C217.599 514.27 218.148 514.581 218.861 514.577C219.587 514.574 220.595 514.166 221.88 513.057C223.511 511.649 225.743 509.041 228.742 504.757C229.006 504.382 228.914 503.861 228.538 503.598C228.161 503.334 227.641 503.426 227.377 503.802C224.492 507.921 222.36 510.441 220.791 511.795C219.941 512.529 219.334 512.909 218.854 512.911C218.659 512.912 218.553 512.763 218.461 512.576C218.253 512.149 218.165 511.543 218.132 510.84C217.955 507.023 219.631 500.655 219.631 500.655C219.748 500.21 219.481 499.755 219.036 499.639C218.591 499.523 218.135 499.789 218.019 500.234Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M273.813 512.019C273.813 512.019 273.618 514.699 272.835 517.119C272.586 517.887 272.279 518.629 271.892 519.239C271.567 519.751 271.194 520.169 270.729 520.374C270.14 520.633 269.438 520.483 268.566 519.878C266.842 518.682 264.691 515.889 261.934 510.67C261.719 510.264 261.214 510.108 260.807 510.323C260.401 510.538 260.245 511.042 260.46 511.449C262.649 515.593 264.505 518.274 266.062 519.893C267.205 521.081 268.22 521.726 269.097 521.997C270.85 522.539 272.193 521.761 273.177 520.318C275.053 517.565 275.475 512.139 275.475 512.139C275.508 511.681 275.163 511.281 274.704 511.248C274.246 511.214 273.846 511.56 273.813 512.019Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M311.619 507.178C311.619 507.178 316.952 512.284 321.207 514.422C322.407 515.026 323.536 515.393 324.462 515.414C325.242 515.431 325.904 515.218 326.417 514.767C327.067 514.196 327.516 513.176 327.488 511.51C327.453 509.46 326.705 506.261 324.886 501.517C324.722 501.088 324.239 500.873 323.81 501.038C323.38 501.202 323.166 501.684 323.331 502.114C325.048 506.592 325.789 509.603 325.822 511.538C325.839 512.53 325.702 513.175 325.316 513.515C325.032 513.765 324.63 513.784 324.169 513.719C323.51 513.627 322.757 513.336 321.956 512.933C317.876 510.884 312.773 505.975 312.773 505.975C312.441 505.657 311.913 505.668 311.594 506C311.276 506.331 311.287 506.859 311.619 507.178Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.216 409.299C267.434 409.299 269.235 410.873 269.235 412.81C269.235 414.748 267.434 416.322 265.216 416.322C262.998 416.322 261.197 414.748 261.197 412.81C261.197 410.873 262.998 409.299 265.216 409.299ZM265.129 410.911C266.614 410.911 267.985 411.512 267.985 412.81C267.985 414.109 266.702 415.072 265.216 415.072C263.73 415.072 262.447 414.109 262.447 412.81C262.447 411.512 263.643 410.911 265.129 410.911Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.173 416.188C266.815 420.295 266.172 428.561 266.172 428.561C266.192 428.905 267.613 429.257 267.957 429.237C268.301 429.217 268.565 428.921 268.544 428.577C268.544 428.577 268.027 419.961 266.334 415.724C266.206 415.404 265.842 415.247 265.522 415.375C265.201 415.503 265.045 415.867 265.173 416.188Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M254.88 476.617C254.903 473.948 255.037 471.982 255.341 470.54C255.603 469.295 255.969 468.484 256.556 467.985C257.267 467.382 258.258 467.261 259.574 467.242C261.913 467.207 265.157 467.585 269.594 467.287C271.362 467.169 272.924 467.351 274.848 467.291C276.606 467.236 278.345 467.441 279.859 468.464C281.952 469.878 283.953 472.238 284.767 477.836C284.833 478.292 285.257 478.607 285.712 478.541C286.167 478.475 286.483 478.052 286.417 477.597C285.503 471.312 283.529 468.117 281.18 466.531C279.364 465.304 277.292 465.007 275.184 465.073C273.24 465.133 271.269 465.505 269.482 465.624C265.084 465.919 261.868 465.541 259.549 465.575C257.759 465.602 256.444 465.894 255.477 466.714C254.814 467.277 254.297 468.095 253.935 469.303C253.462 470.883 253.243 473.204 253.213 476.603C253.209 477.063 253.579 477.44 254.039 477.444C254.499 477.448 254.876 477.077 254.88 476.617Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M287.921 469.395C287.841 469.367 287.701 469.325 287.591 469.311C287.471 469.295 287.331 469.286 287.181 469.284C285.601 469.26 283.251 469.914 283.251 469.914C282.861 470.021 282.461 469.793 282.351 469.405C282.241 469.017 282.471 468.615 282.861 468.508C282.861 468.508 285.741 467.726 287.481 467.837C288.661 467.911 289.381 468.462 289.401 469.271C289.421 469.703 289.211 470.336 288.521 471.154C287.291 472.611 284.361 474.987 278.571 478.741C278.231 478.959 277.781 478.863 277.561 478.525C277.341 478.188 277.441 477.736 277.781 477.517C283.751 473.644 286.591 471.328 287.611 469.956C287.751 469.76 287.871 469.513 287.921 469.395Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M255.041 468.174C255.001 468.165 254.591 468.076 254.291 468.081C253.561 468.093 252.621 468.292 251.981 468.734C251.701 468.932 251.471 469.177 251.441 469.51C251.391 469.916 251.611 470.387 252.081 470.97C253.331 472.499 256.231 474.485 261.851 477.053C262.221 477.22 262.381 477.653 262.211 478.019C262.041 478.385 261.611 478.547 261.251 478.379C257.011 476.442 254.261 474.801 252.561 473.44C251.341 472.456 250.631 471.591 250.281 470.862C249.921 470.105 249.901 469.451 250.081 468.9C250.261 468.351 250.641 467.891 251.151 467.535C252.161 466.836 253.711 466.553 254.751 466.637C255.351 466.685 255.801 466.879 256.021 467.097C256.311 467.376 256.321 467.838 256.051 468.128C255.781 468.41 255.331 468.427 255.041 468.174Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M267.982 445.905C275.185 445.25 283.24 447.33 283.004 456.099C282.856 461.59 277.423 466.377 270.218 467.032C263.015 467.687 258.448 466.216 256.265 458.308C254.803 453.014 260.779 446.56 267.982 445.905ZM268.8 448.333C271.146 448.12 273.513 448.118 275.59 448.572C277.41 448.971 279.003 449.712 280.041 451.08C280.939 452.263 281.396 453.888 281.338 456.053C281.209 460.827 276.33 464.803 270.067 465.372C266.274 465.717 263.288 465.521 261.113 463.704C259.675 462.504 258.632 460.618 257.872 457.865C257.425 456.248 258.051 454.606 259.216 453.159C261.258 450.623 264.945 448.684 268.8 448.333Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M269.106 451.537C273.933 450.743 277.167 452.134 277.287 453.94C277.518 457.405 274.387 458.117 269.538 458.762C264.689 459.406 260.621 459.456 260.753 455.955C260.82 454.147 261.381 452.808 269.106 451.537ZM263.763 455.488C264.163 455.488 264.738 455.959 264.738 456.359C264.738 456.759 264.163 457.268 263.763 457.268C263.363 457.268 263.039 456.759 263.039 456.359C263.039 455.959 263.363 455.488 263.763 455.488ZM274.444 454.186C274.844 454.186 275.169 454.511 275.169 454.91C275.169 455.31 274.844 455.955 274.444 455.955C274.045 455.955 273.411 455.31 273.411 454.91C273.411 454.511 274.045 454.186 274.444 454.186Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M225.994 465.689C225.994 465.689 229.783 453.244 240.71 444.981C240.985 444.773 241.04 444.38 240.832 444.105C240.624 443.83 240.231 443.776 239.956 443.984C228.697 452.498 224.798 465.325 224.798 465.325C224.698 465.655 224.884 466.005 225.214 466.105C225.544 466.205 225.894 466.019 225.994 465.689Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M244.498 442.362C247.087 439.757 250.688 438.769 250.688 438.769C251.02 438.678 251.216 438.333 251.125 438.001C251.034 437.668 250.689 437.472 250.357 437.564C250.357 437.564 246.433 438.642 243.611 441.481C243.368 441.726 243.369 442.122 243.614 442.365C243.859 442.608 244.255 442.607 244.498 442.362Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M264.048 460.671C264.048 460.671 269.057 464.333 275.753 460.013C275.946 459.889 276.002 459.631 275.877 459.437C275.753 459.244 275.495 459.188 275.301 459.313C269.141 463.287 264.536 459.996 264.536 459.996C264.349 459.861 264.088 459.903 263.954 460.09C263.819 460.276 263.862 460.536 264.048 460.671Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M270.06 462.299C269.548 463.212 269.092 463.699 268.715 463.92C268.311 464.156 267.957 464.148 267.652 464.015C267.275 463.851 266.964 463.442 266.754 462.988C266.484 462.407 266.364 461.776 266.364 461.776C266.321 461.551 266.47 461.332 266.695 461.289C266.922 461.245 267.14 461.395 267.183 461.62C267.183 461.62 267.283 462.15 267.509 462.637C267.629 462.896 267.77 463.157 267.985 463.252C268.116 463.308 268.258 463.247 268.441 463.097C268.76 462.833 269.119 462.333 269.538 461.509C269.617 461.354 269.729 461.281 269.839 461.246C269.951 461.212 270.081 461.212 270.222 461.281C270.292 461.316 270.379 461.379 270.469 461.474C270.589 461.601 270.741 461.809 270.912 462.04C271.088 462.277 271.287 462.541 271.505 462.747C271.654 462.889 271.802 463.016 271.965 463.018C272.113 463.021 272.233 462.895 272.381 462.665C272.62 462.293 272.846 461.687 273.063 460.766C273.115 460.543 273.34 460.404 273.564 460.456C273.788 460.509 273.927 460.734 273.875 460.958C273.573 462.235 273.228 462.977 272.895 463.37C272.585 463.734 272.26 463.857 271.952 463.851C271.662 463.846 271.37 463.717 271.1 463.499C270.785 463.246 270.489 462.869 270.243 462.536C270.186 462.46 270.122 462.376 270.06 462.299Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M266.93 447.043C266.93 447.043 265.958 445.158 266.582 443.006C267.007 441.54 268.179 439.974 270.837 438.755C271.098 438.636 271.213 438.326 271.093 438.065C270.973 437.804 270.664 437.689 270.403 437.809C267.363 439.203 266.067 441.04 265.581 442.716C264.839 445.279 266.005 447.523 266.005 447.523C266.138 447.778 266.452 447.878 266.707 447.745C266.963 447.613 267.063 447.299 266.93 447.043Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M271.623 435.961C272.377 435.792 273.166 436.452 273.385 437.433C273.604 438.414 273.17 439.347 272.417 439.515C271.662 439.683 270.873 439.024 270.654 438.043C270.435 437.062 270.869 436.129 271.623 435.961ZM271.85 436.978C271.92 436.962 271.979 437.016 272.037 437.065C272.198 437.2 272.314 437.413 272.369 437.66C272.425 437.907 272.41 438.15 272.321 438.34C272.29 438.409 272.259 438.484 272.19 438.499C272.12 438.515 272.06 438.46 272.002 438.411C271.841 438.277 271.725 438.063 271.67 437.816C271.615 437.569 271.629 437.327 271.718 437.136C271.749 437.068 271.78 436.993 271.85 436.978Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.223 501.912C218.223 501.912 222.166 505.598 226.739 505.658C227.543 505.669 228.205 505.024 228.216 504.219C228.227 503.415 227.582 502.753 226.777 502.742C223.247 502.695 220.227 499.793 220.227 499.793C219.643 499.24 218.719 499.266 218.166 499.85C217.612 500.435 217.638 501.359 218.223 501.912Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M262.712 513.678C262.712 513.678 269.892 515.255 274.132 514.016C274.902 513.791 275.342 512.98 275.122 512.208C274.892 511.435 274.082 510.991 273.312 511.217C269.612 512.297 263.362 510.833 263.362 510.833C262.572 510.655 261.792 511.148 261.612 511.933C261.442 512.718 261.932 513.5 262.712 513.678Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M313.793 508.309C313.793 508.309 319.743 507.992 324.573 503.605C325.163 503.064 325.203 502.141 324.663 501.545C324.123 500.95 323.203 500.906 322.603 501.447C318.583 505.106 313.633 505.397 313.633 505.397C312.823 505.442 312.213 506.131 312.253 506.935C312.303 507.738 312.993 508.354 313.793 508.309Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M306.043 402.792C306.922 400.265 308.103 398.977 309.37 398.617C310.423 398.319 311.471 398.719 312.256 399.438C313.483 400.563 314.112 402.499 313.097 404.132C311.702 406.378 309.591 407.33 307.688 408.38C305.435 409.624 303.441 410.986 302.654 413.959C302.522 414.459 302.821 414.973 303.321 415.105C303.821 415.237 304.334 414.939 304.467 414.439C305.1 412.047 306.781 411.022 308.594 410.022C310.758 408.827 313.104 407.675 314.69 405.122C315.785 403.357 315.659 401.356 314.812 399.736C313.97 398.125 312.411 396.917 310.698 396.684C308.491 396.385 305.85 397.637 304.272 402.176C304.102 402.665 304.361 403.199 304.85 403.369C305.339 403.539 305.873 403.28 306.043 402.792Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M321.488 424.659C321.47 424.427 321.643 424.133 321.828 423.824C322.185 423.23 322.701 422.625 323.09 422.422C324.066 421.912 325.251 421.731 326.041 422.257C326.519 422.574 326.779 423.17 326.773 424.055C326.771 424.344 326.575 424.699 326.343 425.081C325.887 425.83 325.212 426.607 324.674 427.088C324.505 427.238 324.258 427.322 323.995 427.408C323.603 427.537 323.173 427.639 322.774 427.762C322.029 427.991 321.388 428.32 321.017 428.801C320.675 429.243 320.451 429.81 320.295 430.436C320.114 431.162 320.028 431.979 319.825 432.682C319.681 433.179 319.967 433.7 320.464 433.844C320.961 433.988 321.481 433.701 321.625 433.204C321.804 432.587 321.901 431.887 322.038 431.228C322.139 430.743 322.245 430.278 322.501 429.946C322.581 429.843 322.712 429.786 322.852 429.724C323.111 429.61 323.41 429.526 323.713 429.442C324.556 429.207 325.408 428.946 325.922 428.487C326.688 427.803 327.679 426.624 328.209 425.584C328.492 425.03 328.645 424.499 328.648 424.068C328.66 422.373 327.995 421.304 327.079 420.695C325.78 419.831 323.827 419.923 322.223 420.761C321.624 421.073 320.77 421.946 320.221 422.858C319.802 423.555 319.578 424.279 319.618 424.802C319.658 425.318 320.109 425.705 320.625 425.665C321.141 425.625 321.528 425.175 321.488 424.659Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M301.43 419.347C301.44 419.03 301.558 418.791 301.715 418.611C301.942 418.348 302.288 418.191 302.685 418.206C303.393 418.232 304.182 418.882 304.032 419.788C303.959 420.234 303.742 420.545 303.472 420.751C303.436 420.867 303.391 420.982 303.337 421.088C303.147 421.466 302.854 421.735 302.585 421.849C302.224 422.001 301.912 421.975 301.656 421.879C301.299 421.745 301.007 421.435 300.887 421.004C300.728 420.432 300.932 419.719 301.43 419.347Z"
        fill={imageColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M320.884 437.901C320.849 437.915 320.815 437.928 320.784 437.937C320.495 438.028 320.189 438.042 319.889 437.943C319.603 437.848 319.289 437.651 319.036 437.194C318.784 436.742 318.948 436.17 319.4 435.919C319.753 435.723 320.178 435.78 320.467 436.028C320.52 436.003 320.57 435.981 320.6 435.97C320.755 435.912 320.897 435.895 321.015 435.897C321.314 435.904 321.554 436.019 321.744 436.233C321.864 436.367 322.011 436.587 322.011 436.982C322.011 437.5 321.591 437.92 321.074 437.92C321.009 437.92 320.946 437.913 320.884 437.901ZM320.137 437.019L320.136 436.982C320.136 436.995 320.137 437.007 320.137 437.019Z"
        fill={imageColor}
      />
    </svg>
  );
}
